import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { getImage } from "gatsby-plugin-image"
import type { GatsbyImageProps } from "gatsby-plugin-image"
import { PreloadedImage } from "../../PreloadedImage"

const imgQuery = graphql`
  {
    img: file(relativePath: { eq: "Banners/NewHalva/banner_card.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
  }
`

export default function Img(props: Omit<GatsbyImageProps, "image">) {
  const { img } = useStaticQuery(imgQuery)

  return <PreloadedImage {...props} image={getImage(img)!} />
}
